import { render, staticRenderFns } from "./CarrierRename.vue?vue&type=template&id=1f8c1e8e&"
import script from "./CarrierRename.vue?vue&type=script&lang=js&"
export * from "./CarrierRename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports